/** @jsx jsx */
import Link from '@bottlebooks/gatsby-theme-base/src/components/Link/Link';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';
import { jsx } from 'theme-ui';

export default function Logo({ to, href, ...rest }) {
  const {
    event: { logo, name },
  } = useStaticQuery(query);
  if (!logo) return null;
  if (!to && !href) {
    return (
      <Image
        fixed={logo.fixed}
        fadeIn={false}
        alt={name}
        style={{ height: null }}
        sx={{ height: 160 }}
      />
    );
  }
  return (
    <Link to={to} href={href} {...rest}>
      <Logo />
    </Link>
  );
}

const query = graphql`
  {
    event {
      name
      logo {
        fixed(
          width: 500
          height: 262
          crop: PAD
          background: "#FFF0"
          gravity: WEST
        ) {
          src
          srcSet
          width
          height
        }
      }
    }
  }
`;
